import { IPopupOrder, IProduct } from "../../@types/interface";
import Image from 'next/image';
import { useEffect, useRef, useState } from "react";
import environment from "../../utils/environment";

const PopupSizeGuide = ({
    setIsOpen,
    url,
    isRentRule=false
}: any) => {

    let wrapperRef: any = useRef();
    useEffect(() => {
    }, []);

    const handleClick = (event: any) => {
        const { target } = event
        if (!wrapperRef.current.contains(target)) {
            setIsOpen(false)
        }
    }

    return (
        <div id="map_popup" className="wrap_popup" onClick={handleClick}>
            <div ref={wrapperRef} className="sizeguide_pop m-2 lg:m-o lg:max-w-[800px] flex-col relative">
                {/* <a className="close" onClick={() => { setIsOpen(false) }}>&times;</a> */}
                {
                    !isRentRule && url &&
                    <Image
                        src={environment.baseImageUrl + url}
                        alt="size_guide"
                        className="w-auto h-auto relative"
                        layout="fill"
                        objectFit="cover"
                    />
                }
                {
                    isRentRule &&
                    <div style={{
                            padding: "1rem",
                            overflowY: "scroll",
                            lineHeight: "2rem"
                        }}>
                        <h3 style={{ textAlign: "justify", marginTop: "12px"}}>
                            <span style={{fontSize: "15pt"}}><strong>I. Thủ tục thuê:</strong></span>
                        </h3>
                        <p style={{textAlign: "justify"}}>
                            Khi thuê đồ tại Hoài Giang shop, Quý khách vui lòng thanh toán tiền thuê và giấy tờ thế chân. Những giấy tờ thế chân được chấp nhận: Giấy CMND, Hộ Chiếu (Passport), Cavet xe
                        </p>
                        <p style={{paddingLeft: "30px"}}>
                            {`1. Trường hợp Giấy tờ thế chân hợp lệ: "Thanh toán 2 lần tiền thuê + Giấy tờ thế chân".`}
                        </p>
                        <p style={{paddingLeft: "30px"}}>
                            {`2. Quý khách không có giấy tờ thế chân: "Đặt cọc 100% giá trị của từng sản phẩm thuê"`}
                        </p>
                        <p style={{textAlign: "justify"}}>
                            Trường hợp Quý khách muốn đặt đồ trước ngày lấy, Quý khách vui lòng đặt cọc trước 30% hóa đơn thuê, và thanh toán phần tiền thuê còn lại khi nhận đồ.
                        </p>
                        <p style={{textAlign: "justify"}}>
                            Shop chỉ hỗ trợ đổi size (nếu không vừa) , không hoàn tiền lại khi quý khách đã mang đồ về hoặc hủy đặt hàng.
                        </p>
                        <p style={{textAlign: "justify"}}>
                            Khi hoàn tất trả đồ sẽ được hoàn trả giấy tờ thế chân hoặc tiền cọc.
                        </p>
                        <h3 style={{ textAlign: "justify", marginTop: "12px"}}>
                            <span style={{fontSize: "15pt"}}>
                                <strong>II. Thời gian thuê:</strong>
                            </span>
                        </h3>
                        <p style={{textAlign: "justify"}}>
                            Thời gian thuê được tính theo 
                            <strong>{`"gói 3 ngày tính tiền 1 ngày"`}</strong> 
                            kể từ ngày nhận đồ, không kể sáng hay chiều.
                        </p>
                        <p style={{textAlign: "justify"}}>
                            Nếu quá thời gian thuê, chúng tôi sẽ tính thêm phí phụ thuê 20%/ngày trễ
                        </p>
                        <p style={{textAlign: "justify"}}>
                            Ví dụ: Quý khách lấy đồ trong ngày 05-10-2017, thì thời gian trả đồ sẽ trước 18h ngày 07-10-2017.
                        </p>
                        <p style={{textAlign: "justify"}}>Thời gian làm việc:</p>
                        <p style={{textAlign: "justify", paddingLeft: "40px"}}>Thứ 2 - Thứ 7: 9h00 - 18h00</p>
                        <p style={{paddingLeft: "40px"}}>Chủ nhật: Chi nhánh 3 vẫn hoạt động</p>
                        <p style={{paddingLeft: "110px"}}>(Chi nhánh 1 và 2 nghỉ)</p>
                        <h3 style={{ textAlign: "justify", marginTop: "12px"}}>
                            <span style={{fontSize: "15pt"}}>
                                <strong>III. Trách nhiệm của cửa hàng:</strong>
                            </span>
                        </h3>
                        <p style={{textAlign: "justify"}}>- Tư vấn khách hàng về giá cả và cách sử dụng sản phẩm thuê</p>
                        <p style={{textAlign: "justify"}}>
                            - Trang phục cho thuê tại Hoài Giang shop luôn trong tình trạng sử dụng tốt, đã được giặt ủi sạch sẽ, đầy đủ số lượng, và đúng với phiếu đặt hàng của khách.
                        </p>
                        <h3 style={{ textAlign: "justify", marginTop: "12px"}}>
                            <span style={{fontSize: "15pt"}}><strong>IV. Trách nhiệm của khách hàng:</strong></span>
                        </h3>
                        <p style={{textAlign: "justify"}}>
                            - Quý khách vui lòng kiểm tra kỹ trang phục, đạo cụ, hoặc phụ kiện đính kèm theo trang phục trước khi nhận sản phẩm. Hoài Giang shop không chịu trách nhiệm như: thiếu số lượng, hư hỏng... sau khi đã bàn giao.
                        </p>
                        <p style={{textAlign: "justify"}}>
                            - Trong thời gian sử dụng, Quý khách có trách nhiệm bảo quản tốt sản phẩm trong thời gian thuê.
                        </p>
                        <p style={{textAlign: "justify"}}>
                            - Sản phẩm khi giao trả phải ở trong tình trạng tốt như khi được giao. Mọi vấn đề phát sinh: hư hỏng, rách, sờn vải, lem màu, sai khác kiểu dáng ban đầu, thiếu số lượng, trường hợp dính bẩn nhiều khó giặt (quần, váy dài ...) do khách hàng mà không thể khắc phục. Quý khách phải bồi hoàn giá trị của sản phẩm đó, tùy theo tình trạng lúc thuê (xem tại bảng giá thuê). Riêng những sản phẩm bị dính bẩn nhiều, Hoài Giang shop sẽ tính phí phụ thu giặt đồ. Hoặc Quý khách tự giặt rồi trả cho shop.
                        </p>
                        <h3 style={{ textAlign: "justify", marginTop: "12px"}}>
                            <span style={{fontSize: "15pt"}}><strong>V. Ưu đãi:</strong></span>
                        </h3>
                        <p style={{textAlign: "justify"}}>
                            - Hoài Giang shop cho thuê tặng thêm ưu đãi về thời gian cho Quý khách thuê trang phục với gói 
                            <strong>{`"Gói dịch vụ 3 ngày tính tiền 1 ngày"`}</strong> 
                            nhằm tạo cho Quý khách có điều kiện chuẩn bị tốt tiết mục biểu diễn hoặc sự kiện ...
                        </p>
                        <p style={{textAlign: "justify"}}>
                            - Giảm giá cho số lượng, khách hàng thân thiết, học sinh, sinh viên...
                        </p>
                        <p style={{textAlign: "justify"}}>- Có nhận giao hàng tận nơi cho khách.</p>
                        <p><br/></p>
                    </div>
                }
                <Image
                    onClick={() => setIsOpen(false)}
                    src={"/asset/icon/ico_close_circle.svg"}
                    alt="close"
                    className="w-[24px] h-[24px] lg:w-[40px] lg:h-[40px] absolute top-[-10px] lg:top-[-15px] left-[96%] lg:left-[97%] z-[1000]"
                    layout="fill"
                    objectFit="cover"
                />
            </div>

        </div>
    )
}

export default PopupSizeGuide;